module.exports = __webpack_public_path__ + "static/media/neutral.37fa189a.hdr";